module.exports = __webpack_public_path__ + "static/media/back-arrow.svg.13b4bd42.png";